import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

const LightTheme = React.lazy(() => import('./LightTheme'));

const ThemeSelector = ({ children }) => {

  // const isDarkMode = useSelector((state) => state.customizer.isDark);
  return (
    <>
      <LightTheme />
      {children}
    </>
  );
};

ThemeSelector.propTypes = {
  children: PropTypes.node,
};

export default ThemeSelector;
